<script lang="ts" module>
	export const symbolFilledId = "ishavskraft-icon-star-filled";
	export const symbolOutlineId = "ishavskraft-icon-star-outline";
	export const symbol = `
		<symbol id="${symbolFilledId}" viewBox="0 0 24 24">
		<path
			d="M12.0003 17.2752L7.85033 19.7752C7.667 19.8919 7.47533 19.9419 7.27533 19.9252C7.07533 19.9085 6.90033 19.8419 6.75033 19.7252C6.60033 19.6085 6.48366 19.4629 6.40033 19.2882C6.317 19.1135 6.30033 18.9175 6.35033 18.7002L7.45033 13.9752L3.77533 10.8002C3.60866 10.6502 3.50466 10.4792 3.46333 10.2872C3.422 10.0952 3.43433 9.90786 3.50033 9.7252C3.56633 9.54253 3.66633 9.39253 3.80033 9.2752C3.93433 9.15786 4.11766 9.08286 4.35033 9.0502L9.20033 8.6252L11.0753 4.1752C11.1587 3.9752 11.288 3.8252 11.4633 3.7252C11.6387 3.6252 11.8177 3.5752 12.0003 3.5752C12.183 3.5752 12.362 3.6252 12.5373 3.7252C12.7127 3.8252 12.842 3.9752 12.9253 4.1752L14.8003 8.6252L19.6503 9.0502C19.8837 9.08353 20.067 9.15853 20.2003 9.2752C20.3337 9.39186 20.4337 9.54186 20.5003 9.7252C20.567 9.90853 20.5797 10.0962 20.5383 10.2882C20.497 10.4802 20.3927 10.6509 20.2253 10.8002L16.5503 13.9752L17.6503 18.7002C17.7003 18.9169 17.6837 19.1129 17.6003 19.2882C17.517 19.4635 17.4003 19.6092 17.2503 19.7252C17.1003 19.8412 16.9253 19.9079 16.7253 19.9252C16.5253 19.9425 16.3337 19.8925 16.1503 19.7752L12.0003 17.2752Z"
		/>
		</symbol>
		<symbol id="${symbolOutlineId}" viewBox="0 0 24 24">
		<path
			d="M8.85033 16.8252L12.0003 14.9252L15.1503 16.8502L14.3253 13.2502L17.1003 10.8502L13.4503 10.5252L12.0003 7.1252L10.5503 10.5002L6.90033 10.8252L9.67533 13.2502L8.85033 16.8252ZM12.0003 17.2752L7.85033 19.7752C7.667 19.8919 7.47533 19.9419 7.27533 19.9252C7.07533 19.9085 6.90033 19.8419 6.75033 19.7252C6.60033 19.6085 6.48366 19.4629 6.40033 19.2882C6.317 19.1135 6.30033 18.9175 6.35033 18.7002L7.45033 13.9752L3.77533 10.8002C3.60866 10.6502 3.50466 10.4792 3.46333 10.2872C3.422 10.0952 3.43433 9.90786 3.50033 9.7252C3.56633 9.54253 3.66633 9.39253 3.80033 9.2752C3.93433 9.15786 4.11766 9.08286 4.35033 9.0502L9.20033 8.6252L11.0753 4.1752C11.1587 3.9752 11.288 3.8252 11.4633 3.7252C11.6387 3.6252 11.8177 3.5752 12.0003 3.5752C12.183 3.5752 12.362 3.6252 12.5373 3.7252C12.7127 3.8252 12.842 3.9752 12.9253 4.1752L14.8003 8.6252L19.6503 9.0502C19.8837 9.08353 20.067 9.15853 20.2003 9.2752C20.3337 9.39186 20.4337 9.54186 20.5003 9.7252C20.567 9.90853 20.5797 10.0962 20.5383 10.2882C20.497 10.4802 20.3927 10.6509 20.2253 10.8002L16.5503 13.9752L17.6503 18.7002C17.7003 18.9169 17.6837 19.1129 17.6003 19.2882C17.517 19.4635 17.4003 19.6092 17.2503 19.7252C17.1003 19.8412 16.9253 19.9079 16.7253 19.9252C16.5253 19.9425 16.3337 19.8925 16.1503 19.7752L12.0003 17.2752Z"
		/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		filled = false,
		class: classes = null,
		ariaHidden = true,
	}: {
		filled?: boolean;
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

{#if filled}
	<svg
		aria-hidden={ariaHidden}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		class={classes}
		fill="currentColor"
	>
		<use href="#{symbolFilledId}" />
	</svg>
{:else}
	<svg
		aria-hidden={ariaHidden}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		class={classes}
		fill="currentColor"
	>
		<use href="#{symbolOutlineId}" />
	</svg>
{/if}
